import { render, staticRenderFns } from "./LandingFooter.vue?vue&type=template&id=2fbec8fe&scoped=true"
import script from "./LandingFooter.vue?vue&type=script&lang=js"
export * from "./LandingFooter.vue?vue&type=script&lang=js"
import style0 from "./LandingFooter.vue?vue&type=style&index=0&id=2fbec8fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbec8fe",
  null
  
)

export default component.exports